import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dca9a518"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog-footer" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 保存 ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 取消 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: _ctx.id ? '编辑排序' : '新建排序' ,
    "before-close": _ctx.dialogHandle.close,
    width: 900,
    "close-on-click-modal": false
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        _createVNode(_component_el_button, {
          loading: _ctx.dialogHandle.loading,
          type: "primary",
          onClick: _ctx.dialogHandle.submit
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["loading", "onClick"]),
        _createVNode(_component_el_button, {
          loading: _ctx.dialogHandle.loading,
          type: "info",
          onClick: _ctx.dialogHandle.close
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["loading", "onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref: "formRef",
        model: _ctx.dialogHandle.formData,
        rules: _ctx.dialogHandle.rules
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "排序id",
            required: "",
            prop: "priority",
            class: "form_input"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.dialogHandle.formData.priority,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dialogHandle.formData.priority) = $event)),
                placeholder: "请输入内容"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "排序名称",
            required: "",
            prop: "name",
            class: "form_input form_name"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.dialogHandle.formData.name,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dialogHandle.formData.name) = $event)),
                placeholder: "请输入内容"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "投放渠道",
            prop: "product_code",
            "show-message": false,
            required: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_radio_group, {
                modelValue: _ctx.dialogHandle.formData.product_code,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dialogHandle.formData.product_code) = $event)),
                max: 1
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clientList, (item) => {
                    return (_openBlock(), _createBlock(_component_el_radio, {
                      key: item.value,
                      label: item.value
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["title", "before-close"]))
}